var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5819 4.9543C21.1796 4.5461 20.5731 4.4123 20.0355 4.6086L3.00475 10.7736C2.45785 10.9621 2.08045 11.4357 2.01935 12.009C1.95925 12.5715 2.21755 13.1008 2.67755 13.3791L5.72245 15.3449C6.08865 15.5773 6.56425 15.5842 6.93435 15.3576L17.2737 8.585L7.59355 16.2804C7.39285 16.4523 7.25765 16.6906 7.21265 16.9484L6.76635 19.4757C6.65455 20.1085 6.93045 20.7159 7.46995 21.0245C8.00705 21.3311 8.66035 21.2696 9.13545 20.8624L11.3582 18.9562L14.7718 21.1876C15.0076 21.3419 15.2845 21.421 15.5643 21.421C15.7323 21.421 15.9017 21.3927 16.0638 21.3341C16.4984 21.1769 16.8255 20.8351 16.953 20.421L21.8905 6.461C22.0961 5.9346 21.9778 5.3566 21.5819 4.9543Z",
    fill: "#00B885"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.4226425f257cc6dbcc8aa7c0b9039f74.svg";
export { ForwardRef as ReactComponent };